import { trackApplicationEvent } from 'tracking/application/trackApplicationEvent';

export const trackFieldFilling = trackApplicationEvent('FIELD_FILLED');
export const trackFormSubmission = trackApplicationEvent('FORM_SUBMITTED');
export const trackShortFormSubmission = trackApplicationEvent('SHORT_FORM_SUBMITTED');
export const trackProgressiveDisclosureForm = trackApplicationEvent('PROGRESSIVE_DISCLOSURE_SUBMITTED');
export const trackProgressiveDisclosureNextField = trackApplicationEvent('PROGRESSIVE_DISCLOSURE_NEXT_FIELD');
